webpackJsonp([263791100135453],{

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(40);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sfu = 'https://www.sfu.ca/';
	var compsci = 'https://www.sfu.ca/computing.html';
	var dots = 'https://github.com/dsmftw/dotfiles';
	
	var AboutPage = function AboutPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'About'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'em',
	        null,
	        'Hello, thanks for stopping by!'
	      ),
	      ' I\'m Igor Kozlov, a full-stack software developer and a recent ',
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', rel: 'nofollow', href: sfu },
	        'SFU'
	      ),
	      ' grad, ',
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', rel: 'nofollow', href: compsci },
	        'Computing Science Major'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Back-end software development is my passion and main area of expertise. I love working with databases, tackling algorithmic problems, and experimenting with code. While I\'m not working/studying I like to spend time customizing ',
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', rel: 'nofollow', href: dots },
	        'my Gentoo Linux machine'
	      ),
	      ', getting involved with amature astronomy, playing soccer and hockey, snowboarding, and hiking the countless mauntain trails in my home province, Beautiful British Columbia.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Oh, and I also build a daily-driven race/drag car as a "side project" \u263A'
	    )
	  );
	};
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-a9ffcd538de0ef436f1b.js